import { render, staticRenderFns } from "./UnionActivityCell.vue?vue&type=template&id=4cb8a060&"
import script from "./UnionActivityCell.vue?vue&type=script&lang=js&"
export * from "./UnionActivityCell.vue?vue&type=script&lang=js&"
import style0 from "./UnionActivityCell.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports